const qs = require('qs')
const Request = require('@/repositories/request')
const { encodeQueryParams } = require('~/util/query')
class Invitation extends Request {
  /**
   *
   * @param {{_where: Object,
        _limit: int,
        _start: int}} params
   * @returns {*}
   */
  findAll(params) {
    const stringifyParams = qs.stringify(
      { ...params },
      { arrayFormat: 'comma' }
    )
    return this.$strapi.$invitations.find(stringifyParams)
  }

  async withUsers(params) {
    const stringifyParams = qs.stringify({ ...params }, { encode: false })
    return await this.$strapi.$http.$get(
      `/invitations/withUsers?${stringifyParams}`
    )
  }

  /**
   *
   * @param {{_where: Object,
        _limit: int,
        _start: int}} params
   * @returns {*}
   */
  count(params) {
    const stringifyParams = qs.stringify({ ...params })
    return this.$strapi.$invitations.count(stringifyParams)
  }

  /**
   *
   * @param {int} id
   * @return {Promise<unknown>}
   */
  resend(id) {
    return this.$strapi.$http.$get(`/invitations/${id}/resend`)
  }

  /**
   *
   * @param {int} id
   * @returns {*}
   */
  findOne(id) {
    return this.$strapi.$invitations.findOne(id)
  }

  /**
   * @param {int} id
   * @param {Object} data
   * @returns {*}
   */
  update(id, data) {
    return this.$strapi.$invitations.update(id, data)
  }

  countPilotInvitationsFromDate(dateStart) {
    return this.$strapi.$http.$get(
      `/invitations/pilot/count?date_start=${dateStart}`
    )
  }

  confirmInterview(body) {
    return this.$strapi.$http.$post('/invitations/interview', body)
  }

  previewMail(params) {
    return this.$strapi.$http.get(
      `/invitations/preview?${encodeQueryParams(params)}`
    )
  }

  previewReminderMail(params) {
    return this.$strapi.$http.get(
      `/invitations/reminder/preview?${encodeQueryParams(params)}`
    )
  }

  findAllJobSeekerFair(params) {
    return this.$strapi.$http.$get(
      `/invitations/job-seeker-fair?${encodeQueryParams(params)}`
    )
  }

  massResendInvitations(body) {
    return this.$strapi.$http.$post('/invitations/send-massive', body)
  }

  massResendAllInvitations(body) {
    return this.$strapi.$http.$post('/invitations/send-massive-all', body)
  }

  sendMassReminder(body) {
    return this.$strapi.$http.$post('/invitations/send-mass-reminder', body)
  }

  massValidateUsers(body) {
    return this.$strapi.$http.$post('/invitation/validate-excel', body)
  }

  massValidateCollaborators(body) {
    return this.$strapi.$http.$post(
      '/invitation/validate-supervisor-or-collaborator-excel',
      body
    )
  }

  massValidateSupervisors(body) {
    return this.$strapi.$http.$post(
      '/invitation/validate-supervisor-or-collaborator-excel',
      body
    )
  }

  massValidateCollaboratorsAndSupervisors(body) {
    return this.$strapi.$http.$post(
      '/invitation/validate-supervisor-and-collaborator-excel',
      body
    )
  }

  newMassCreateUsers(body) {
    return this.$strapi.$http.$post('/users/massive', body)
  }

  newMassCreateCollaborators(body) {
    return this.$strapi.$http.$post('/users/collaborators-massive', body)
  }

  newMassCreateSupervisors(body) {
    return this.$strapi.$http.$post('/users/supervisors-massive', body)
  }

  newMassCreateSupervisorsAndCollaborators(body) {
    return this.$strapi.$http.$post(
      '/users/supervisors-collaborators-massive',
      body
    )
  }

  newSingleCreateUsers(body) {
    body.user.user_origin = process.env.USER_ORIGIN || 'relink'
    return this.$strapi.$http.$post('/users/workers', body)
  }

  sendAllProjectInvitation(body) {
    body.user_origin = process.env.USER_ORIGIN || 'relink'
    return this.$strapi.$http.$post('/invitations/send-project', body)
  }

  sendInvitationByUserIds(body) {
    return this.$strapi.$http.$post('/invitations/send-massive-by-user', body)
  }

  newSingleCreateCollaborators(body) {
    body.user.user_origin = process.env.USER_ORIGIN || 'relink'
    return this.$strapi.$http.$post('/users/collaborators', body)
  }

  newSingleCreateSupervisors(body) {
    body.user.user_origin = process.env.USER_ORIGIN || 'relink'
    return this.$strapi.$http.$post('/users/supervisors', body)
  }

  toSupervisorsReminder(body) {
    return this.$strapi.$http.$post('/invitations/supervisor-reminder', body)
  }

  addExistingCollaboratorsToProjectAndNotify(body) {
    return this.$strapi.$http.$post(
      '/users/add-existing-collaborators-to-project-and-notify',
      body
    )
  }

  addExistingSupervisorsToProjectAndNotify(body) {
    return this.$strapi.$http.$post(
      '/users/add-existing-supervisors-to-project-and-notify',
      body
    )
  }

  collaboratorEmployeeReminderInvitation(body) {
    return this.$strapi.$http.$post(
      '/invitations/reminder/collaborator-employee',
      body
    )
  }

  collaboratorEmployeeProgressQuestionaryReminderInvitation(body) {
    return this.$strapi.$http.$post(
      '/invitations/reminder/collaborator-employee-progress-questionary',
      body
    )
  }

  supervisorReminderInvitation(body) {
    return this.$strapi.$http.$post('/invitations/reminder/supervisor', body)
  }

  previewCollaboratorEmployeeReminderInvitationMail(params) {
    return this.$strapi.$http.get(
      `/invitations/reminder/preview-collaborator-employee?${encodeQueryParams(
        params
      )}`
    )
  }

  previewCollaboratorEmployeeProgressQuestionaryReminderInvitationMail(params) {
    return this.$strapi.$http.get(
      `/invitations/reminder/preview-collaborator-employee-progress-questionary?${encodeQueryParams(
        params
      )}`
    )
  }
}

module.exports = Invitation
